import * as Assets from "./foodiest";

export default Assets;
